/* global G */
import { asyncpipe, setKey } from 'lib/util'
import setContext from 'lib/sequence/module/adapter/session/context'
import aclInit from 'lib/sequence/app/acl/init'
import pubSubInit from 'lib/sequence/app/pubsub/connect'
import setMeta from '@gaia/sequence/module/adapter/session/meta'
import setLanguage from '@gaia/sequence/module/adapter/intl/lang'
import routeComposition from 'trait/composition/route'
import resetNavigationStack from 'lib/sequence/module/adapter/session/navigation'
import { sequenceAppSessionStateRoleSet as setRole } from '@gaia/sequence/app/session/state/meta'
import cartInit from 'lib/sequence/app/init/cart'
import settingsInit from 'lib/sequence/app/init/settings'
import { pluginsLogin } from 'lib/sequence/app/init/plugin'
import notificationsInit from 'lib/sequence/app/init/notifications'
import pinCreatorInit from 'lib/sequence/app/init/pincreator'

/**
 * HTTP middleware filter that excludes `persistence`.
 *
 * @param params              http adapter middleware
 * @param params.persistence  excluded middleware
 * @param params.rest         used middleware
 * @return {any[]}
 */
const middleware = ({ persistence, ...rest }) => Object.values(rest)

/**
 * Sequence Native Application Login
 *
 * Allows the application to authenticate with the server and
 * log in a user after it's been initialised.
 *
 * One can declare any route to be used in the next redirect. The sequence looks for
 * `module[G.STATE][G.ROUTE]` containing a route object like `{ module: 'person', action: 'index'}`.
 * If it's not given it will use the `defaultRoute` defined in application config.
 *
 * @param {Gaia.AppModule.Spec} module the current module composition object
 * @returns {function(*=): *}
 */
const sequenceModuleLogin = module => asyncpipe(
  () => module[G.MODEL][G.ADAPTER][G.HTTP].get({
    url: '/api/v1/public/login',
  }, { middleware }),
  setRole(module),
  setMeta(module),
  setLanguage(module),
  resetNavigationStack(module),
  () => {
    const defaultRoute = module[G.ADAPTER][G.ROUTER].defaultRoute()
    return [
      routeComposition(
        module[G.STATE][G.ROUTE]?.module || defaultRoute.module,
        module[G.STATE][G.ROUTE]?.action || defaultRoute.action,
      ),
    ]
  },
  args => setKey(args[0], G.ROUTE, module[G.STATE]) && args,
  setContext(module),

  pluginsLogin(module),
  aclInit(module),
  settingsInit(module),
  pubSubInit(module),
  cartInit(module),
  notificationsInit(module),
  pinCreatorInit(module),
)

export default sequenceModuleLogin
